"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShadowPosition = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _context = require("../context");

var _layout = require("../layout");

var _utils = require("../utils");

var ShadowPosition;
exports.ShadowPosition = ShadowPosition;

(function (ShadowPosition) {
  ShadowPosition["Top"] = "top";
  ShadowPosition["Bottom"] = "bottom";
})(ShadowPosition || (exports.ShadowPosition = ShadowPosition = {}));

var RowWithShadow = (0, _context.styledWithTheme)(_layout.Row)(function (_ref) {
  var theme = _ref.theme,
      hasShadow = _ref.hasShadow,
      shadowPosition = _ref.shadowPosition;
  var isTop = shadowPosition === ShadowPosition.Top;
  var NEUTRAL90 = theme.selectors.color('neutral90');
  var transparent = (0, _utils.opacify)(NEUTRAL90, 0);
  var shadowColor = (0, _utils.opacify)(NEUTRAL90, 0.2);
  var gradient = isTop ? "linear-gradient(".concat(transparent, ", ").concat(shadowColor, ")") : "linear-gradient(".concat(shadowColor, ", ").concat(transparent, ")");
  return {
    position: 'relative',
    ':before': {
      // The shadow won't appear unless the element has content, and
      // the value needs to include quotes so that they are applied in
      // the actual CSS - `content: ' '` would result in invalid CSS
      // because the string wouldn't be quoted in the DOM.
      content: '" "',
      transition: 'opacity 0.3s',
      opacity: hasShadow ? 1 : 0,
      position: 'absolute',
      top: isTop ? -5 : undefined,
      bottom: isTop ? undefined : -5,
      height: 5,
      left: 0,
      right: 0,
      background: gradient
    }
  };
});
RowWithShadow.displayName = 'RowWithShadow';
RowWithShadow.defaultProps = (0, _objectSpread2.default)({}, _layout.Row.defaultProps);
var _default = RowWithShadow;
exports.default = _default;